module.exports = __webpack_public_path__ + "a2fd0dc06f0b6c2cb1b909f72d6c4fb3.jpg";